import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardBody, Button, Label, Input, Table } from 'reactstrap';
import { toast } from 'react-toastify';
import { api } from '../../config';
import Select from "react-select";
import { fetchComAuth, fetchComAuthJson } from '../../common/api';

const AssociarEstandesComerciais = ({ feiraId }) => {
  const [comerciais, setComerciais] = useState([]);
  const [estandes, setEstandes] = useState([]);
  const [vinculos, setVinculos] = useState([]);
  const [selectedComercial, setSelectedComercial] = useState('');
  const [selectedEstandes, setSelectedEstandes] = useState([]);

  useEffect(() => {
    carregarComerciais();
    carregarEstandes();
    carregarVinculos();
  }, [feiraId]);

  const carregarComerciais = async () => {
    try {
      const res = await fetchComAuth(`${api.API_URL}/feira/comerciais/${feiraId}`, {
        method: 'GET'
      });
      const data = await res.json();
      setComerciais(data.data);
    } catch (err) {
      console.error('Erro ao carregar comerciais:', err);
    }
  };

  const carregarEstandes = async () => {
    try {
      const res = await fetchComAuth(`${api.API_URL}/feira/estandes/${feiraId}`, {
        method: 'GET' 
      });
      const data = await res.json();
      
      setEstandes(data.data.filter(f => f.valor_total > 0)
        .map(f => ({ value: f.id, label: f.nome }))
      );
    } catch (err) {
      console.error('Erro ao carregar estandes:', err);
    }
  };

  const carregarVinculos = async () => {
    try {
      const res = await fetchComAuth(`${api.API_URL}/feira/estandeComercial/${feiraId}`, { method: 'GET'});
      const data = await res.json();
      setVinculos(data.data);
    } catch (err) {
      console.error('Erro ao carregar vínculos:', err);
    }
  };

  const handleAssociar = async () => {
    if (!selectedComercial || selectedEstandes.length === 0) {
      toast.error('Selecione um comercial e pelo menos um estande.');
      return;
    }

    try {
      const res = await fetchComAuthJson(`${api.API_URL}/estandeComercial`, {
        method: 'POST',
        body: JSON.stringify({ 
          feira_id: feiraId, 
          comercial_id: selectedComercial, 
          estandes: selectedEstandes.map(id => ({ estande_id: id }))
        })
      });
      const data = await res.json();
      if (data.success) {
        toast.success('Estandes associados com sucesso!');
        setSelectedEstandes([]);
        setSelectedComercial('');
        carregarVinculos();
      } else {
        toast.error('Erro ao associar.');
      }
    } catch (err) {
      toast.error('Erro na requisição.');
    }
  };

  const handleDesvincular = async (vinculoId) => {
    
    try {
      await fetchComAuth(`${api.API_URL}/estandeComercial/${vinculoId}`, { method: 'DELETE' });
      toast.success('Desvinculado com sucesso.');
      carregarVinculos();
    } catch (err) {
      toast.error('Erro ao desvincular.');
    }
  };

  return (
    <Row>
      <Row md={12}>
        <Card>
          <CardBody>
          <Row>
              <Col lg={6}>
              <div className="mb-6">
                <Label>Selecione um Comercial:</Label>
                <Input 
                  type='select' 
                  value={selectedComercial} 
                  onChange={e => setSelectedComercial(e.target.value)}
                >
                  <option value=''>Selecione...</option>
                  {comerciais.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
                </Input>   
              </div>
              </Col>
              <Col lg={6}>
              <div className="mb-6">
                <Label className='mt-1'>Selecione os Estandes:</Label>
                <Select
                  value={selectedEstandes}
                  isMulti
                  onChange={setSelectedEstandes}
                  options={estandes}
                  placeholder="Selecione ..."
                  styles={{
                    multiValueLabel: (styles) => ({
                      ...styles,
                      color: 'white', // Cor do texto do label
                      fontWeight: 'bold',         // Outras opções de estilo
                    }),
                    multiValue: (styles) => ({
                      ...styles,
                      backgroundColor: '#1a73e8', // Cor do chip como um todo (opcional)
                    }),
                  }}
                />
                  
              </div>
              </Col>
              </Row>
              <Row>
              <Col md={6}>
               
            </Col>
            <Col md={6}>
              
              </Col>
              </Row>
            <Button className='mt-1' color='success' onClick={handleAssociar}>
              Salvar Associação
            </Button>
          </CardBody>
        </Card>
      </Row>

      <Col md={12}>
        <Card>
          <CardBody>
            <Table responsive>
              <thead>
                <tr>
                  <th>Comercial</th>
                  <th>Estande</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {vinculos.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center text-muted">
                      Nenhum vínculo cadastrado
                    </td>
                  </tr>
                ) : (
                  vinculos.map(v => (
                    <tr key={v.id}>
                      <td>{v.comercial.nome}</td>
                      <td>{v.estande.nome}</td>
                      <td>
                        <Button 
                          color='danger' 
                          size='sm' 
                          onClick={() => handleDesvincular(v.id)}
                        >
                          Desvincular
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AssociarEstandesComerciais;